/**
 * @generated SignedSource<<76776a0dd9f8fbe0cec0074a0ba5a4e5>>
 * @relayHash 38dac4d280f1061b565a4f344f61745d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID afd4a8148418253722aabe40c825a47206a3ab3801ebcba1542a16c9fbc39109

import type { ConcreteRequest, Query } from 'relay-runtime';
export type JsmChatConnectedApps = "SLACK" | "TEAMS" | "%future added value";
export type NativeConfigEnabledQuery$variables = {
  jiraProjectAri: string;
};
export type NativeConfigEnabledQuery$data = {
  readonly jsmChat: {
    readonly initializeNativeConfig: {
      readonly connectedApp: JsmChatConnectedApps | null | undefined;
      readonly nativeConfigEnabled: boolean | null | undefined;
    };
  } | null | undefined;
};
export type NativeConfigEnabledQuery = {
  response: NativeConfigEnabledQuery$data;
  variables: NativeConfigEnabledQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "jiraProjectAri"
  }
],
v1 = [
  {
    "concreteType": "JsmChatQuery",
    "kind": "LinkedField",
    "name": "jsmChat",
    "plural": false,
    "selections": [
      {
        "args": [
          {
            "kind": "Variable",
            "name": "jiraProjectAri",
            "variableName": "jiraProjectAri"
          }
        ],
        "concreteType": "JsmChatInitializeNativeConfigResponse",
        "kind": "LinkedField",
        "name": "initializeNativeConfig",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "nativeConfigEnabled"
          },
          {
            "kind": "ScalarField",
            "name": "connectedApp"
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "NativeConfigEnabledQuery",
    "selections": (v1/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "NativeConfigEnabledQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": "afd4a8148418253722aabe40c825a47206a3ab3801ebcba1542a16c9fbc39109",
    "metadata": {},
    "name": "NativeConfigEnabledQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "eca7adbc2cba5d0f749362ca84cdd8eb";

export default node;
